import Confirm from 'components/Confirm';
/**
 * ReactDOM é um pacote que fornece métodos específicos do DOM que podem
 * ser usados no nível superior do seu aplicativo e como uma saída de 
 * emergencia para sair do modelo React.
 */
import ReactDOM from 'react-dom';

/**
 * Alert é um substituto do `window.confirm()` nativo
 * do javascript com a diferença de que esse está
 * estilizado em um modal com a identidade visual
 * do projeto. Apenas um confirm por vez pode ser
 * disparado e ele pode ter um callback quando resposta
 * positiva e um callback adicional opcional quando
 * fechar, resposta positiva, ou negativa
 *
 * @param title {string} Título do cabeçalho do alert, default: "Geobahia informa:"
 * @param message {string|ReactDOM} O que aparecerá no corpo da mensagem do alert
 * @param callback {function} Função que será executada logo após resposta positiva do confirm
 * @param buttonText {string} Texto que aparecerá no botão
 * @param finallyCallback {function} Função que será executada logo após fechamento ou qualquer resposta do confirm
 * @param gap {number} define o espaçamento entre os botões de cancelar e confirmar
 */
/**
 * ReactDOM.render() função recebe dois argumentos, codigo HTML e um 
 * elemento html, a função tem como objetivo exibir o codigo HTML espe-
 * cificado dentro do elemento HTML especificado.
 */
export default ({ title, message, buttonText, callback, finallyCallback, gap }) => {
  ReactDOM.render(
    <Confirm
      title={title}
      message={message}
      buttonText={buttonText}
      callback={callback}
      finallyCallback={finallyCallback}
      gap={gap}
    />,
    document.getElementById('alert')
  );
};



